import { Component, Input,  OnInit ,  Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-message-header',
  templateUrl: './message-header.component.html',
  styleUrls: ['./message-header.component.scss']
})
export class MessageHeaderComponent implements OnInit {
	userName: String;
	@Input() showHeader: Boolean;
  @Output() emitPass: EventEmitter<any> = new EventEmitter<any>();
  constructor(private router: Router) { }

  ngOnInit(): void {
    this.userName = localStorage.getItem('name');
    console.log(localStorage.getItem('locale'))
  }
  logout() {
	  localStorage.clear();
    this.showHeader = false;
    this.emitPass.emit(this.showHeader);
	  this.router.navigate(['/']);
  }
}
